<template>
  <div>
    <a-modal
      :dialog-style="{ top: '20px' }"
      title="Merge To Other Customer"
      :destroyOnClose="true"
      :visible="isModalShow"
      :maskClosable="false"
      @cancel="() => { this.$emit('close-change', 0) }"
      :width="'90%'"
      :wrapClassName="'merge-customer-modal'"
    >
      <a-spin :spinning="loading" style="background: #fff;">
        <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
      </a-spin>
      <a-row v-show="!loading">
        <a-col :span="12">
          <cdb-customer-edit
            ref="customerEditComponentLeft"
            :record="mergeToRecord"
            :isShowEdit="true"
            :isMainShow="true"
            :isMergeMode="true"
            :activeTabKey="activeTabKey"
            :webSiteType="webSiteType"
            @tab-change="handleTabChange"
            @web-site-type-change="handleWebSiteTypeChange"
            @data-loaded="handleComponentLoaded"
          ></cdb-customer-edit>
        </a-col>
        <a-col :span="12">
          <cdb-customer-edit
            ref="customerEditComponent"
            :record="mergeData"
            :isShowEdit="true"
            :isMainShow="false"
            :isMergeMode="true"
            :activeTabKey="activeTabKey"
            :webSiteType="webSiteType"
            @tab-change="handleTabChange"
            @web-site-type-change="handleWebSiteTypeChange"
            @data-loaded="handleComponentLoaded"
          ></cdb-customer-edit>
        </a-col>
      </a-row>
      <template slot="footer">
        <a-button type="primary" :loading="saving" @click="handleNext">
          Next
        </a-button>
        <a-button @click="() => { this.$emit('close-change', 0) }">
          Close
        </a-button>
      </template>
    </a-modal>
    <a-modal
      v-if="previewData"
      :dialog-style="{ top: '20px' }"
      title="Preview"
      :destroyOnClose="true"
      :visible="true"
      :maskClosable="false"
      @cancel="() => { this.previewData = null }"
      width="1000px"
      :wrapClassName="'preview-modal'"
    >
      <cdb-customer-preview
        :activeTabKey="activeTabKey"
        :previewData="previewData"
      />
      <template slot="footer">
        <a-button type="primary" :loading="saving" @click="handleSave">
          Save
        </a-button>
        <a-button @click="() => { this.previewData = null }">
          Close
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
// import moment from 'moment'
import CdbCustomerEdit from '@/views/cdbnew/customernew/CdbCustomerEdit'
import CdbCustomerPreview from '@/views/cdbnew/customernew/components/CdbCustomerPreview'
import CustomerApi from '@/api/api-cdb-custome-v2'

export default {
  name: 'CdbCustomerMergePage',
  components: {
    CdbCustomerEdit,
    CdbCustomerPreview
  },
  props: {
    mergeToRecord: {
      type: Object,
      default: () => { }
    },
    mergeData: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      loading: true,
      saving: false,
      isModalShow: true,
      activeTabKey: '1',
      webSiteType: 'Signet',
      componentsLoaded: 0,
      previewData: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.loading = true
      this.componentsLoaded = 0
    },
    handleComponentLoaded () {
      this.componentsLoaded++
      if (this.componentsLoaded >= 2) {
        this.loading = false
      }
    },
    handleNext () { 
      this.saving = true
      const customerEditComponent = this.$refs.customerEditComponent
      if (customerEditComponent) {
        try {
          const parameter = this.getSubmitData()
          CustomerApi.previewMergeCus(this.mergeToRecord.id, parameter).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.previewData = res.data || null
            }
          }).catch((e) => {
            console.log('preview-error', e)
          }).finally(() => {
            this.saving = false
          })
        } catch (error) {
          this.$message.error(error.message)
          this.saving = false
          return
        }
      }
    },
    handleTabChange (key) {
      this.activeTabKey = key
      this.$refs.customerEditComponent.currentActiveTabKey = key
      this.$refs.customerEditComponentLeft.currentActiveTabKey = key
      this.webSiteType = 'Signet'
    },
    handleWebSiteTypeChange (value) {
      this.webSiteType = value
    },
    handleSave () { 
      this.saving = true
      const customerEditComponent = this.$refs.customerEditComponent
      if (customerEditComponent) {
        try {
          const parameter = this.getSubmitData()
          CustomerApi.mergeCus(this.mergeToRecord.id, parameter).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Save success !')
              this.previewData = null
              this.$emit('close-change', 1)
            }
          }).catch((e) => {
            console.log('save-error', e)
          }).finally(() => {
            this.saving = false
          })
        } catch (error) {
          this.$message.error(error.message)
          this.saving = false
          return
        }
      }
    },
    getSubmitData () { 
      const customerEditComponent = this.$refs.customerEditComponent
      const basicMergeComponent = customerEditComponent.$refs.basicMergeComponent
      const couponComponent = customerEditComponent.$refs.couponComponent
      const tourComponent = customerEditComponent.$refs.tourComponent
      const tourRecordComponent = tourComponent.$refs.tourRecordList
      const tourListComponent = tourComponent.$refs.tourListComponent
      const customerAirlines = tourListComponent.$refs.customerAirlines
      const passportPage = customerEditComponent.$refs.passportPage
      const passportListComponent = passportPage.$refs.passportListComponent
      const otherDocumentsListComponent = passportPage.$refs.otherDocumentsListComponent

      const passportListComponentSelected = passportPage && passportListComponent ? passportListComponent.selectedRow : []
      const otherDocumentListComponentSelected = passportPage && otherDocumentsListComponent ? otherDocumentsListComponent.selectedRow : []
      const ffpListComponentSelected = tourComponent && tourListComponent && customerAirlines ? customerAirlines.selectedRow : []
      const signetCouponCodeListSelected = couponComponent ? couponComponent.selectedRowKeys : []
      const superaCouponCodeListSelected = couponComponent ? couponComponent.superaSelectedRowKeys : []
      const signetRecordIdListSelected = tourComponent && tourRecordComponent ? tourRecordComponent.selectedRowKeys : []
      const superaRecordIdListSelected = tourComponent && tourRecordComponent ? tourRecordComponent.superaSelectedRowKeys : []
      const bkcIdListSelected = tourComponent && tourListComponent ? tourListComponent.selectedBkcIdList : []

      const addressListSelected = basicMergeComponent.selectedAddressList || []
      const selectedBasic = basicMergeComponent.selectedBasic || {}
      const selectedEmergencyContact = basicMergeComponent.selectedEmergencyContact || null
      const selectedEmailList = basicMergeComponent.selectedEmailList || []
      const selectedPhoneList = basicMergeComponent.selectedPhoneList || []
      const selectedRelationships = basicMergeComponent.selectedRelationships || []

      const hasSelectedData = 
        passportListComponentSelected.length > 0 ||
        otherDocumentListComponentSelected.length > 0 ||
        ffpListComponentSelected.length > 0 ||
        signetCouponCodeListSelected.length > 0 ||
        superaCouponCodeListSelected.length > 0 ||
        signetRecordIdListSelected.length > 0 ||
        superaRecordIdListSelected.length > 0 ||
        addressListSelected.length > 0 ||
        selectedBasic.birthday ||
        selectedBasic.firstName ||
        selectedBasic.lastName ||
        selectedBasic.middleName ||
        selectedBasic.preferToBeCalled ||
        selectedBasic.gender ||
        selectedBasic.languages ||
        selectedBasic.otherLanguages ||
        selectedBasic.nationalBackground ||
        selectedBasic.ethnicitiesId ||
        selectedBasic.title ||
        selectedBasic.roomPreferred ||
        selectedBasic.mealsRequest ||
        selectedBasic.specialRequest ||
        selectedEmergencyContact ||
        selectedEmailList.length > 0 ||
        selectedPhoneList.length > 0 ||
        selectedRelationships.length > 0

      if (!hasSelectedData) {
        throw new Error('Please select at least one record or fill in some information to merge.')
      }

      // 处理日期格式
      passportListComponentSelected.forEach(item => {
        item.expirationDate = item.expirationDate ? this.dateFormat(item.expirationDate) : null
        item.birthday = item.birthday ? this.dateFormat(item.birthday) : null
      })
      otherDocumentListComponentSelected.forEach(item => {
        item.expirationDate = item.expirationDate ? this.dateFormat(item.expirationDate) : null
        item.birthday = item.birthday ? this.dateFormat(item.birthday) : null
      })

      return {
        mergeCdbMainCode: this.mergeData.globalCode,
        passportList: passportListComponentSelected,
        otherPassportList: otherDocumentListComponentSelected,
        ffpList: ffpListComponentSelected,
        signetCouponCodeList: signetCouponCodeListSelected,
        superaCouponCodeList: superaCouponCodeListSelected,
        signetRecordIdList: signetRecordIdListSelected,
        superaRecordIdList: superaRecordIdListSelected,
        addressList: addressListSelected,
        birthday: selectedBasic.birthday || null,
        firstName: selectedBasic.firstName || null,
        lastName: selectedBasic.lastName || null,
        middleName: selectedBasic.middleName || null,
        nickName: selectedBasic.preferToBeCalled || null,
        gender: selectedBasic.gender || null,
        language: selectedBasic.languages || null,
        otherLanguages: selectedBasic.otherLanguages || null,
        nationalBackground: selectedBasic.nationalBackground || null,
        ethnicitiesId: selectedBasic.ethnicitiesId || null,
        title: selectedBasic.title || null,
        roomPreferred: selectedBasic.roomPreferred || null,
        mealsRequest: selectedBasic.mealsRequest || null,
        specialRequest: selectedBasic.specialRequest || null,
        emergencyContact: selectedEmergencyContact,
        contactList: [
          ...(selectedEmailList), 
          ...(selectedPhoneList)
        ],
        rsList: selectedRelationships,
        bkcIdList: bkcIdListSelected
      }
    },
  },
  watch: {
  }
}
</script>
<style lang="less" scoped>
::v-deep .merge-customer-modal .ant-modal-body, ::v-deep .preview-modal .ant-modal-body {
  background: #f6f6f6 !important;
  padding: 10px !important;
}

</style>
